import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Menu,
  MenuButtonProps,
  MenuItem,
} from '@chakra-ui/react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { FC } from 'react';

import {
  INavigationItems,
  MOBILE_NAV_PADDING_X,
  MOBILE_NAV_WIDTH,
} from '@/components/ui/shared/headers/CoreHeader/components/constants';
import { NavLink } from '@/components/ui/shared/links/NavLink/NavLink';

interface ICoreNavigationMenuDropdownMobileProps extends MenuButtonProps {
  navigationTitle: string;
  navigationItems: Array<INavigationItems>;
}

export const MenuDropdownMobile: FC<ICoreNavigationMenuDropdownMobileProps> = ({
  navigationTitle,
  navigationItems,
  ...rest
}) => {
  const router = useRouter();

  return (
    <Flex display={{ base: 'block', lg: 'none' }} w="full">
      <Menu variant="navigation" colorScheme="blackAlpha" placement="bottom-end" {...rest}>
        <Accordion allowMultiple minWidth={MOBILE_NAV_WIDTH} width="full" border={0}>
          <AccordionItem border={0}>
            <h2>
              <AccordionButton border={0} fontWeight={700} px={MOBILE_NAV_PADDING_X} py={3}>
                <Box as="span" flex="1" textAlign="left" _hover={{ background: 'none', textDecoration: 'underline' }}>
                  {navigationTitle}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              {navigationItems &&
                navigationItems.map((item: INavigationItems) => (
                  <NextLink href={item.href} passHref key={item.id} legacyBehavior>
                    <NavLink
                      as={MenuItem}
                      isActiveLink={router.asPath.startsWith(item.href)}
                      _hover={{ background: 'none', textDecoration: 'underline' }}
                    >
                      {item.title}
                    </NavLink>
                  </NextLink>
                ))}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Menu>
    </Flex>
  );
};
